﻿import {translation} from "@2d-front-monorepo/core";
import {
	DialogProvider,
	ErrorDialog,
	LoadingDialog,
	useScrollToTop,
	useSetScrollbarWidth
} from "@2d-front-monorepo/design-library";
import {JSX, useMemo, useRef} from "react";
import {Outlet} from "react-router";

// @ts-ignore
import * as logos from "url:../images/logos/*.*";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {LanguageSelector} from "../components/LanguageSelector";
import Loader from "../components/Loader";
import {getGlobalContext} from "../hooks/getGlobalContext";
import {useLogout} from "../hooks/useLogout";
import {useUser} from "../hooks/useUser";
import {APP_VERSION} from "../version";

export function MainLayout(): JSX.Element {
	const user = useUser();
	const logout = useLogout();

	const mainRef = useRef<HTMLElement>(null);
	const isAuthorized = user.authStatus == "logged-in";

	const data = useMemo(() => {
		const installation = getGlobalContext().installation;
		const logo = logos[installation.slug];
		return {name: installation.name, logo: logo?.["svg"] ?? logo?.["png"]};
	}, []);

	useScrollToTop(mainRef);
	useSetScrollbarWidth(mainRef);

	return (<DialogProvider>
		<header>
			<button type="button" popoverTarget="navigation-menu" className="material-symbols-rounded"
			        hidden={!isAuthorized}
			        aria-label="menu" aria-haspopup="menu" aria-controls="navigation-menu"
			        id="menu-button">menu
			</button>

			<a href="/"><img src={data.logo} alt={data.name} height="64"/></a>

			<span id="logout-button">
				<LanguageSelector hidden={isAuthorized}/>
				<button type="button" className="form__button form__button--small" onClick={logout} hidden={!isAuthorized}>
					{translation(PermitTranslations.log_out)}
				</button>
				<span>{APP_VERSION}</span>
			</span>

		</header>
		<main ref={mainRef}><Outlet/></main>
		<ErrorDialog/>
		<LoadingDialog><Loader/></LoadingDialog>
	</DialogProvider>);
}
